<template>
    <div class="title">
        <div class="title_top">
            <van-icon
                style="position: absolute; left: 10px"
                size="25"
                name="arrow-left"
                @click="to()"
            />
            <div class="my">职称</div>
            <div class="determine" @click="ondetermine">确定</div>
        </div>
        <div class="title_bottm">
            <van-field
                center
                is-link
                readonly
                clickable
                name="picker"
                :value="value"
                label="职称等级"
                placeholder="请选择"
                @click="showPicker = true"
                style="height: 48px"
            />
            <van-popup v-model="showPicker" position="bottom">
                <van-picker
                    show-toolbar
                    :columns="columns"
                    @confirm="onConfirm"
                    @cancel="showPicker = false"
                />
            </van-popup>
            <van-cell-group>
                <van-field
                    :disabled="disabled"
                    center
                    style="border-radius: 8px; height: 48px"
                    v-model="values"
                    placeholder="请输入"
                    label="职称"
                >
                </van-field>
            </van-cell-group>
        </div>
    </div>
</template>

<script>
import { Toast } from "vant";
export default {
    name: "title",
    data() {
        return {
            disabled: false,
            value: "",
            values: "",
            valuess: "",
            showPicker: false,
            userInfo: "",
            columns: [],
            columnss: [],
        };
    },
    created() {
        if (sessionStorage.getItem("scholarUserInfos")) {
            this.userInfo = JSON.parse(sessionStorage.getItem("scholarUserInfos"));
            // console.log(this.userInfo);
        } else {
            sessionStorage.setItem("scholarUserInfos", sessionStorage.getItem("scholarUserInfo"));
        }
        this.getTitleList();
    },
    methods: {
        to() {
            window.history.go(-1);
        },
        // 点击确定
        ondetermine() {
            if (!this.userInfo.sysUserTitle) {
                this.userInfo.sysUserTitle = [];
            }
            if (this.value == "") {
                Toast("职称等级不能为空");
            } else if (this.values == "" && this.value !== "无职称") {
                Toast("职称不能为空");
            } else {
                for (let i = 0; i < this.columnss.length; i++) {
                    if (this.columnss[i].titleName == this.value) {
                        this.valuess = this.columnss[i];
                    }
                }
                this.userInfo.sysUserTitle.push({
                    levelOneName: this.value,
                    levelTwo: this.values,
                    levelOne: this.valuess.titleCode,
                });
                sessionStorage.setItem("scholarUserInfos", JSON.stringify(this.userInfo));
                this.$router.push("information");
            }
        },
        // 选择等级
        async getTitleList() {
            const { data } = await this.$apis.userServe.getTitleList();
            this.columnss = data;
            for (let i = 0; i < data.length; i++) {
                this.columns.push(data[i].titleName);
            }
        },
        onConfirm(value) {
            this.value = value;
            this.disabled = value === "无职称";
            this.showPicker = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.title {
    width: 100vw;
    min-height: 100vh;
    overflow: hidden;
    background: #f5f5f5;

    .title_top {
        height: 44px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #fff;
        line-height: 44px;
        align-content: center;
        position: relative;

        .my {
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            background: #fff;
            text-align: center;
        }

        .determine {
            font-size: 15px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            position: absolute;
            right: 15px;
        }
    }

    .title_bottm {
        width: 94%;
        margin: 12px auto;
        background: #fff;
        border-radius: 8px;

        .van-cell--clickable {
            border-radius: 8px;
        }

        .van-hairline--top-bottom {
            border-radius: 8px;
        }
    }

    .prompt {
        width: 94%;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        margin: 0 auto;
    }
}
</style>
